function NotFound() {
    return (<div>
        Khong tim thay trang!
    </div>);
}

export default NotFound;